module.exports = __webpack_public_path__ + "img/mobile-login-logo.0b2237c5.png";